import { BaseComponent } from '../core/BaseComponent';

export class AdvancedSelect extends BaseComponent {
  private trigger: HTMLElement | null = null;
  private menu: HTMLElement | null = null;
  private search: HTMLInputElement | null = null;
  private optionsList: HTMLElement[] = [];

  protected init(): void {
    super.init();
    this.trigger = this.element.querySelector('.select-trigger');
    this.menu = this.element.querySelector('.select-menu');
    this.search = this.element.querySelector('.select-search input');
    this.optionsList = Array.from(this.element.querySelectorAll('.select-option'));
    
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.toggle());
    }
    
    if (this.search) {
      this.search.addEventListener('input', (e) => this.filter((e.target as HTMLInputElement).value));
    }
    
    this.optionsList.forEach(opt => {
      opt.addEventListener('click', () => {
        this.select(opt);
        this.hide();
      });
    });
  }

  public toggle(): void {
    this.menu?.classList.contains('d-none') ? this.show() : this.hide();
  }

  public show(): void {
    this.menu?.classList.remove('d-none');
    if (this.search) setTimeout(() => this.search?.focus(), 50);
    const close = (e: MouseEvent) => {
      if (!this.element.contains(e.target as Node)) { 
        this.hide(); 
        document.removeEventListener('click', close as any); 
      }
    };
    setTimeout(() => document.addEventListener('click', close as any), 0);
  }

  public hide(): void {
    this.menu?.classList.add('d-none');
  }

  private filter(query: string): void {
    const q = query.toLowerCase();
    this.optionsList.forEach(opt => {
      const match = opt.textContent?.toLowerCase().includes(q);
      opt.classList.toggle('d-none', !match);
    });
  }

  public select(opt: HTMLElement): void {
    this.optionsList.forEach(o => o.classList.remove('selected'));
    opt.classList.add('selected');
    if (this.trigger) {
      const label = this.trigger.querySelector('.select-label');
      if (label) label.textContent = opt.textContent?.trim() || '';
    }
    this.emit('change', { value: opt.getAttribute('data-value') });
  }
}
